import { SealCheck, Warning, WarningCircle } from "@phosphor-icons/react";

const STYLES = {
  High: { border: "border-sky-300", bg: "bg-sky-50", text: "text-sky-800", Icon: SealCheck },
  Medium: { border: "border-amber-300", bg: "bg-amber-50", text: "text-amber-800", Icon: Warning },
  Low: { border: "border-rose-300", bg: "bg-rose-50", text: "text-rose-800", Icon: WarningCircle },
};

export const EvidenceConfidence = ({ level, coverage, unknownCount, testId = "evidence-confidence" }) => {
  const s = STYLES[level] || STYLES.Medium;
  return (
    <div className={`border ${s.border} ${s.bg} p-5`} data-testid={testId}>
      <div className="flex items-center justify-between gap-3">
        <p className="overline text-slate-500">Evidence confidence</p>
        <s.Icon size={20} weight="duotone" className={s.text} />
      </div>
      <p className={`mt-2 font-display text-3xl font-extrabold ${s.text}`} data-testid={`${testId}-level`}>
        {level}
      </p>
      <p className="mt-1 text-xs leading-relaxed text-slate-600">
        {coverage}% of scored areas answered with a definite position
        {unknownCount > 0 ? ` · ${unknownCount} answered Don't Know` : ""}
      </p>
      <p className="mt-2 text-[11px] leading-relaxed text-slate-500">
        Reported separately from the readiness score: the score measures your answers, confidence
        measures how well those answers are known.
      </p>
    </div>
  );
};
